import { ApiPath } from "enums";
import { Get } from "utils";

const resolveCampaignCode = (campaignCode) => {
  return (
    campaignCode ||
    localStorage.getItem("campaignCode") ||
    localStorage.getItem("organizationId") ||
    ""
  );
};

export const getTotalProcessedResponses = async ({ campaignCode } = {}) => {
  const res = await Get(`${ApiPath.SurveyAnalyticsTotalProcessedResponses}`, {
    campaignCode: resolveCampaignCode(campaignCode),
  });
  return res.data;
};

export const getCategoryDistribution = async ({ campaignCode } = {}) => {
  const res = await Get(`${ApiPath.SurveyAnalyticsCategoryDistribution}`, {
    campaignCode: resolveCampaignCode(campaignCode),
  });
  return res.data;
};

export const getSentimentDistribution = async ({ campaignCode } = {}) => {
  const res = await Get(`${ApiPath.SurveyAnalyticsSentimentDistribution}`, {
    campaignCode: resolveCampaignCode(campaignCode),
  });
  return res.data;
};

export const getEmploymentSectorDistribution = async ({ campaignCode } = {}) => {
  const res = await Get(`${ApiPath.SurveyAnalyticsEmploymentSectorDistribution}`, {
    campaignCode: resolveCampaignCode(campaignCode),
  });
  return res.data;
};

export const getEnumeratorPerformance = async ({ campaignCode } = {}) => {
  const res = await Get(`${ApiPath.SurveyAnalyticsEnumeratorPerformance}`, {
    campaignCode: resolveCampaignCode(campaignCode),
  });
  return res.data;
};

export const getKeyConcerns = async ({ campaignCode } = {}) => {
  const res = await Get(`${ApiPath.SurveyAnalyticsKeyConcerns}`, {
    campaignCode: resolveCampaignCode(campaignCode),
  });
  return res.data;
};

export const getAgeDistribution = async ({ campaignCode } = {}) => {
  const res = await Get(`${ApiPath.SurveyAnalyticsAgeDistribution}`, {
    campaignCode: resolveCampaignCode(campaignCode),
  });
  return res.data;
};

export const getSexDistribution = async ({ campaignCode } = {}) => {
  const res = await Get(`${ApiPath.SurveyAnalyticsSexDistribution}`, {
    campaignCode: resolveCampaignCode(campaignCode),
  });
  return res.data;
};
